// extracted by mini-css-extract-plugin
export default {"wrapper":"rfS4_5","select":"kK9k9O","arrow-down":"lNEkYo","arrowDown":"lNEkYo","ltr":"lZmucv","rtl":"W4pjJo"};